const getLanguageFromUrl = () => {
  const pathSegments = window.location.pathname.split('/')
  const lang = pathSegments[1]

  return lang === 'en' ? 'en' : 'ar'
}

export default getLanguageFromUrl
